/* eslint-disable import/no-anonymous-default-export */
import http from "./httpService";
import { default as apiConfing } from "../config.json";
import { AxiosResponse } from "axios";
import { BoardingSlider } from "../pages/OnboardingPage/OnBoardingSlider";
import { CustomPopUp } from "../typings/customPopUp";

const apiUrl = apiConfing.IS_DEVELOPMENT ? apiConfing.API_DEVELOPMENT : apiConfing.API_PRODUCTION;

const apiEndpoint = `${apiUrl}/AppSettings`;


export function getOnboardingScreens(): Promise<AxiosResponse<BoardingSlider[]>> {
  const url = `${apiEndpoint}/GetOnboardingScreens`;
  return http.get(url);
}

export function getCurrentReactVersion() {
  const url = `${apiEndpoint}/IsReactUpToDate?version=${apiConfing.REACT_VERSION}`;
  return http.post(url);
}

export function getApplicationPageContentText(id: number) {
  const url = `${apiEndpoint}/GetApplicationPageContentText?id=${id}`;
  return http.get(url);
}

export function getVisableWatchedMeForFreemium() {
  const url = `${apiEndpoint}/GetVisableWatchedMeForFreemium`;
  return http.get(url);
}

export function getGetCustomPopUp(): Promise<AxiosResponse<CustomPopUp>> {
  const url = `${apiEndpoint}/GetActiveCustomPopUp`;
  return http.get(url);
}





export default {
  getOnboardingScreens
};
